export default {
  header: 'Oeps, er is iets onverwachts gebeurd',
  text: 'Herlaad de pagina of klik op de knop „Terug naar menu" hieronder.',
  button: 'Terug naar menu',
};
